import { AppRegistry } from 'react-native';
import CreatePage from './CreatePage';

AppRegistry.registerComponent('App', CreatePage());
AppRegistry.runApplication('App', {
    initialProps: {
        sourceType: 'web',
        rootTag: document.getElementById('root'),
    },
    rootTag: document.getElementById('root'),
});
